"use client";
import { Carousel } from "antd";
import useUIStore from '@/store/useUIStore';
import useMobileDetect from "@/hooks/useMobileDetect";
import { useEffect, useMemo } from "react";
import { isHomePage, handleCardClick } from "@/utils/tools";
import Image from "next/image";
import { CardType } from "@/types/index";

type NotifyType = {
  "pic"?: string,
  "name": string,
  "locate": string,
  "link_type"?: number,
  "open_type"?: number,
  "link"?: string
}

type headerProps = {
  isFirst?: boolean,
  notifyList: NotifyType[]
};

export default function Index({
  isFirst = false,
  notifyList = []
}: headerProps) {

  const { affixStatus, updateAffixStatus } = useUIStore();
  const isMobile = useMobileDetect();

  const listLeft = notifyList.filter(item => item.locate === 'left')
  const listRight = notifyList.filter(item => item.locate === 'right')

  const affixStatusValue = useMemo(() => {
    if (isFirst) {
      return affixStatus
    } else {
      return !isFirst
    }
  }, [isFirst, affixStatus])

  useEffect(() => {
    updateAffixStatus(false);
  }, [updateAffixStatus]);

  const m_item = (item: NotifyType) => {
    return <h3 className="flex items-center justify-center h-36">
      {
        item.pic ?
          <Image
            src={process.env.NEXT_PUBLIC_IMAGE_URL + item.pic}
            alt={item.name}
            width={20}
            height={20}
            className="mr-12"
            style={affixStatusValue ? {} : { filter: 'brightness(0) invert(1)' }}
          />
          :
          null
      }
      {item.name}
    </h3>
  }

  const pc_item_left = (item: NotifyType) => {
    return <>
      {
        item.pic ?
          <Image
            src={process.env.NEXT_PUBLIC_IMAGE_URL + item.pic}
            alt={item.name}
            width={22}
            height={22}
            className="mr-12"
            // style={{ color: affixStatusValue ? '#402C22' : "#fff" }}
            style={affixStatusValue ? {} : { filter: 'brightness(0) invert(1)' }}
          />
          :
          null
      }
      <h5 style={{ color: affixStatusValue ? '#402C22' : "#fff" }}>
        {item.name || "Timeless Elegance, Sustainable Living"}
      </h5>
    </>
  }

  const pc_item_right = (item: NotifyType, idx: number) => {
    return <h3 className="flex items-center" key={idx}>
      {
        item.pic ?
          <Image
            src={process.env.NEXT_PUBLIC_IMAGE_URL + item.pic}
            alt={item.name}
            width={22}
            height={22}
            className="mr-12"
            style={affixStatusValue ? {} : { filter: 'brightness(0) invert(1)' }}
          />
          :
          null
      }
      {item.name}
    </h3>
  }

  return <div
    data-card-type={CardType.NOTIFICATION}
    data-card-idx={0}
    className={`cardItem ${affixStatusValue ? 'headerIsAffix' : 'text-white '}`}
    onMouseEnter={() => !isMobile && isHomePage() && updateAffixStatus(true)}
    onMouseLeave={() => !isMobile && isHomePage() && updateAffixStatus(false)}
  >
    <div className="h-36 text-center bravve3:hidden">
      <Carousel autoplay infinite waitForAnimate dots={false} dotPosition="left" className={`${affixStatusValue ? '' : 'text-white '}`}>
        {
          listRight.map((item, idx: number) => 
            (<h3 className='h-36 leading-[3.6rem] flex items-center' key={idx}>
              {
                handleCardClick({ ...item, idx }, m_item(item), true)
              }
            </h3>)
          )
        }
      </Carousel>
    </div>

    <div>
      <div
        className='h-36 items-center justify-between hidden px-12 bravve3:flex lg:px-[4rem] contentMaxWidth'
      >
        <div className="flex items-center gap-x-10">
          {
            listLeft.length ?
              handleCardClick({ ...listLeft[0], idx: 'nleft0' }, pc_item_left(listLeft[0]), false)
              :
              null
          }
        </div>
        <div className='flex gap-x-40'>
          {
            listRight.map((item, idx: number) => handleCardClick({ ...item, idx: 'nright' + idx }, pc_item_right(item, idx), false))
          }
        </div>
      </div>
    </div>
  </div>
}